import { Button, Typography, useTheme, alpha } from "@mui/material";
import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { showErrorToast } from "../../../../../components/common/ShowToast";

interface Props {
  canvaLink: string | null;
}

export const CanvaLinkButton: React.FC<Props> = ({ canvaLink }) => {
  const theme = useTheme();

  const openCanvaLink = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    link: string | null
  ) => {
    e.stopPropagation();
    if (!link) {
      showErrorToast("Canva link not available at the moment");
      return;
    }
    window.open(link, "_blank");
  };

  if (!canvaLink) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "text.disabled",
          fontSize: "0.85rem",
          fontWeight: 500,
          userSelect: "none",
        }}
      >
        —
      </Typography>
    );
  }

  return (
    <Button
      size="small"
      variant="outlined"
      onClick={(e) => openCanvaLink(e, canvaLink)}
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        fontSize: "0.74rem",
        fontWeight: 600,
        py: 0.35,
        px: 1.25,
        borderColor: alpha("#00C4CC", 0.5),
        color: theme.palette.mode === "dark" ? "#22d3ee" : "#0891b2",
        backgroundColor: alpha("#00C4CC", 0.06),
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: alpha("#00C4CC", 0.15),
          borderColor: "#00C4CC",
          transform: "translateY(-1px)",
        },
      }}
    >
      <OpenInNewIcon sx={{ fontSize: 13, mr: 0.75 }} /> Open in Canva
    </Button>
  );
};

